var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSidebarNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.641,
    height: 76.368,
    viewBox: "0 0 242.641 76.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 242.641,
    height: 76.368,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-787 -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(787 486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,68.705,81.213,94.323,38.259,59.61Z",
    transform: "translate(0 -17.956)",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,47.724l37.316-8.872L41.762,0Z",
    transform: "translate(0 0)",
    fill: "#c9e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M62.075.721,57.608,39.744l42.918,34.694Z",
    transform: "translate(-17.353 -0.217)",
    fill: "#9bd4d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M223.084,40.017a5.526,5.526,0,0,1,5.569-5.811,5.181,5.181,0,0,1,4.142,1.914l-.705.531a4.454,4.454,0,0,0-3.437-1.569,4.616,4.616,0,0,0-4.575,4.935,4.646,4.646,0,0,0,4.575,4.947,4.562,4.562,0,0,0,3.229-1.361v-2.7h-4.151v-.853h5.1v3.922a5.584,5.584,0,0,1-9.744-3.956",
    transform: "translate(-67.198 -10.304)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M253.94,35.495l-2.606,6.573h5.2ZM257.929,45.7l-1.084-2.756h-5.824L249.938,45.7h-1.1l4.508-11.231h1.166l4.5,11.231Z",
    transform: "translate(-74.957 -10.383)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M264.947,45.7v-.843l6.63-9.512h-6.63v-.876h7.816v.819l-6.629,9.536h6.733V45.7Z",
    transform: "translate(-79.808 -10.383)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 0.934,
    height: 11.231,
    transform: "translate(195.262 24.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M292.56,45.7l-6.928-9.652V45.7H284.7V34.469h.958l6.893,9.513V34.469h.935V45.7Z",
    transform: "translate(-85.757 -10.383)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M300.605,40.017a5.519,5.519,0,0,1,5.569-5.811,5.176,5.176,0,0,1,4.141,1.914l-.7.531a4.436,4.436,0,0,0-3.437-1.569,4.618,4.618,0,0,0-4.578,4.935,4.577,4.577,0,0,0,7.819,3.586v-2.7h-4.163v-.853h5.095v3.922a5.582,5.582,0,0,1-9.742-3.956",
    transform: "translate(-90.549 -10.304)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M241.086,44.824V34.47h-.957V45.7h4.877l.358-.876Z",
    transform: "translate(-72.332 -10.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M224.074,65.888l.6-.713a4.549,4.549,0,0,0,3.446,1.625c2.249,0,2.9-1.281,2.9-2.237,0-3.3-6.607-1.579-6.607-5.5,0-1.845,1.625-3.01,3.62-3.01a4.66,4.66,0,0,1,3.724,1.59l-.623.7a3.91,3.91,0,0,0-3.16-1.419c-1.463,0-2.57.864-2.57,2.075,0,2.882,6.6,1.291,6.6,5.489,0,1.453-.935,3.182-3.91,3.182a4.994,4.994,0,0,1-4.011-1.788",
    transform: "translate(-67.496 -16.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M247.763,61.864c0-2.836-1.718-4.935-4.358-4.935s-4.346,2.1-4.346,4.935,1.692,4.935,4.346,4.935,4.358-2.1,4.358-4.935m-9.7,0c0-3.275,2.11-5.811,5.339-5.811s5.351,2.536,5.351,5.811-2.135,5.812-5.351,5.812-5.339-2.525-5.339-5.812",
    transform: "translate(-71.711 -16.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M256.367,67.559V56.318h.955V66.684h5.328v.876Z",
    transform: "translate(-77.224 -16.964)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M267.438,63.247V56.319h.956v6.906c0,2.282,1.164,3.655,3.333,3.655s3.332-1.372,3.332-3.655V56.319h.958v6.928c0,2.779-1.455,4.509-4.29,4.509s-4.289-1.753-4.289-4.509",
    transform: "translate(-80.558 -16.965)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M286.1,67.559V57.193h-3.6v-.875h8.139v.875h-3.585V67.559Z",
    transform: "translate(-85.097 -16.964)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 0.934,
    height: 11.241,
    transform: "translate(207.508 39.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M311.326,61.864c0-2.836-1.718-4.935-4.359-4.935s-4.347,2.1-4.347,4.935,1.7,4.935,4.347,4.935,4.359-2.1,4.359-4.935m-9.7,0c0-3.275,2.11-5.811,5.338-5.811s5.353,2.536,5.353,5.811-2.136,5.812-5.353,5.812-5.338-2.525-5.338-5.812",
    transform: "translate(-90.858 -16.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M328.122,67.559l-6.929-9.652v9.652h-.935V56.318h.958l6.895,9.524V56.318h.935V67.559Z",
    transform: "translate(-96.469 -16.964)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M335.885,65.888l.611-.713a4.546,4.546,0,0,0,3.446,1.625c2.237,0,2.884-1.281,2.884-2.237,0-3.3-6.6-1.579-6.6-5.5,0-1.845,1.616-3.01,3.61-3.01a4.629,4.629,0,0,1,3.726,1.59l-.625.7a3.9,3.9,0,0,0-3.146-1.419c-1.465,0-2.572.864-2.572,2.075,0,2.882,6.6,1.291,6.6,5.489,0,1.453-.946,3.182-3.909,3.182a5.038,5.038,0,0,1-4.024-1.788",
    transform: "translate(-101.176 -16.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M181.388,57.625l2.592-3.644a11.175,11.175,0,0,0,8.292,3.724c3.771,0,5.211-1.88,5.211-3.689,0-5.616-15.231-2.123-15.231-11.946,0-4.462,3.768-7.863,9.545-7.863a13.413,13.413,0,0,1,9.779,3.769l-2.595,3.483a10.567,10.567,0,0,0-7.621-3.079c-2.664,0-4.4,1.361-4.4,3.32,0,5.016,15.234,1.926,15.234,11.878,0,4.451-3.1,8.3-10.136,8.3a14.144,14.144,0,0,1-10.676-4.253",
    transform: "translate(-54.638 -10.304)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M140.246,34.833l-9.466,15.646v11.1h4.6v-11.1L145.5,34.833Z",
    transform: "translate(-39.394 -10.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M127.628,44.657l-6.146-9.824h-5.26L125.16,48.6Z",
    transform: "translate(-35.009 -10.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M171.584,38.961V34.833H153.631v26.75h17.953V57.455h-13.35v-7.46h7.608l2.618-4.127H158.234V38.961Z",
    transform: "translate(-46.277 -10.492)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebarNew);
export default __webpack_public_path__ + "static/media/logo_sidebar_new.da0e1e5167490b34a182f9e80e5b3e87.svg";
export { ForwardRef as ReactComponent };